// extracted by mini-css-extract-plugin
export default {"link":"newsWidget-module--link--1fdDT"};